import { useQuery } from '@tanstack/react-query';
import { SAVED_FILTERS_QUERY_KEYS } from 'app/modules/filters/queries/keys';
import { FilterContext, SavedFilter } from 'app/modules/filters/models';
import { get } from 'app/shared/utils/fetchr';

interface ListSavedFiltersResponse {
  saved_filters: SavedFilter[];
}

interface Options {
  enabled?: boolean;
}

export const useGetSavedFilters = (
  filterContext: FilterContext | undefined,
  { enabled = true }: Options = {},
) => {
  return useQuery({
    queryKey: SAVED_FILTERS_QUERY_KEYS.list(filterContext as FilterContext),
    queryFn: () =>
      get<ListSavedFiltersResponse>(
        `/saved-filters?filter_context=${filterContext}`,
      ),
    enabled: enabled && Boolean(filterContext),
    select: (data) => data.saved_filters,
  });
};
